<template>
    <div class="page subject-teachers-page">
        <transition name="fade-transition">
            <v-container v-if="subject && !loading" :class="{'py-3 px-3': phoneOnly, 'py-6': pcOnly}">
                <div class="subject-header py-2 py-md-4 mb-6 mb-lg-8 px-2">
                    <div class="d-flex align-start">
                        <div class="subject-header__icon primary d-flex align-center justify-center me-4">
                            <v-icon size="34" color="white">{{ subject.icon || 'mdi-book-education-outline' }}</v-icon>
                        </div>
                        <div class="flex-grow-1">
                            <div class="strong-text--text font-weight-bold mb-2" style="font-size: 1.35rem">{{ subject.name }}</div>
                            <div class="medium-text muted--text mb-3">اختر المعلم ثم تصفح دوراته في هذه المادة</div>
                        </div>
                    </div>
                </div>

                <div v-if="teachers && teachers.length" class="teachers-grid">
                    <v-card
                        v-for="teacher in teachers"
                        :key="teacher.id"
                        flat
                        class="teacher-card overflow-hidden"
                    >
                        <div class="teacher-card__header primary"></div>
                        <div class="teacher-card__body px-4 pb-4 pt-8 text-center">
                            <div class="teacher-card__avatar-wrap">
                                <v-avatar size="96" class="teacher-card__avatar e-link" v-ripple @click="$router.push(teacherLink(teacher.id))">
                                    <v-img :src="teacher.avatar"></v-img>
                                </v-avatar>
                            </div>
                            <router-link tag="div" :to="teacherLink(teacher.id)" class="strong-text--text font-weight-bold medium-text mt-6 e-link">{{ teacher.name }}</router-link>
                            <div class="mb-5 muted--text details-text">
                                <v-icon left size="16">mdi-play-box-multiple-outline</v-icon>
                                {{ unitFormat(teacher.courses_count, 'دورة', 'دورتين', 'دورات') }}
                            </div>
                            <v-btn block depressed color="primary" dark class="teacher-card__btn" :to="teacherLink(teacher.id)">
                                <v-icon left small>mdi-play-circle-outline</v-icon>
                                دورات المعلم
                            </v-btn>
                        </div>
                    </v-card>
                </div>
                <div v-else class="px-2">
                    <v-alert outlined color="blue-grey" text type="info">
                        <div class="medium-text">لا يوجد معلمون متاحون في هذه المادة حالياً</div>
                    </v-alert>
                </div>
            </v-container>
        </transition>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: 'SubjectTeachers',
    data() {
        return {
            subject: null,
            teachers: [],
            loading: false,
        };
    },
    computed: {
        ...GlobalComputed,
        id() {
            return this.$route.params.id;
        },
    },
    watch: {
        loading(loading) {
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,
        teacherLink(teacherId) {
            return {
                name: 'teacher',
                params: { id: teacherId },
                query: { subject_id: this.subject.id },
            };
        },
        loadSubject() {
            if (this.loading) {
                return;
            }
            this.loading = true;
            this.$store.dispatch('fastGetAction', { url: `/subjects/${this.id}` }).then(response => {
                const payload = response.data.data || response.data;
                this.subject = payload;
                this.teachers = payload.teachers || [];
                this.setDocumentTitle(this.subject.name, true);
                this.loading = false;
            }).catch(() => {
                this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                this.loading = false;
            });
        },
    },
    mounted() {
        if (!this.appData.enable_subjects_system) {
            this.$router.push('/not-found');
            return;
        }
        this.loadSubject();
    },
};
</script>

<style lang="scss" scoped>
.teachers-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 280px), 1fr));
    gap: 16px;
}

.subject-header__icon {
    width: 72px;
    height: 72px;
    min-width: 72px;
    border-radius: 16px;
}

.v-card.teacher-card {
    border-radius: 16px !important;
    height: 100%;
    background: #f7f7f7;
    border: 1px solid #e0e0e0;
}

.theme--dark .v-card.teacher-card {
    background: var(--v-surface2-base, #1e1e1e);
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.12);
}

.teacher-card__header {
    height: 72px;
    background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.1), transparent 65%);
}

.teacher-card__body {
    position: relative;
    background: #f7f7f7;
}

.theme--dark .teacher-card__body {
    background: var(--v-surface2-base, #1e1e1e);
}

.teacher-card__avatar-wrap {
    position: absolute;
    top: -38px;
    left: 50%;
    transform: translateX(-50%);
}

.teacher-card__avatar {
    border: 3px solid #fff;
}

.teacher-card__btn {
    border-radius: 10px !important;
    text-transform: none;
    font-weight: 600;
}
</style>
